import { Injectable } from '@angular/core';
import { KeycloakAuthService } from './keycloak-auth.service';
import { ConfigService } from './config.service';
import { PortalApp } from '../app.interface';

@Injectable({ providedIn: 'root' })
export class AppService {
  constructor(
    private keycloakAuth: KeycloakAuthService,
    private configService: ConfigService
  ) {}

  async getValidAudiences(): Promise<string[]> {
    try {
      const loggedIn = await this.keycloakAuth.isLoggedIn();
      if (!loggedIn) return [];

      await this.keycloakAuth.updateToken(5);
      const resourceKeys = this.keycloakAuth.getResourceAccessKeys();
      const excluded = this.configService.getExcludedAudiences();
      return resourceKeys.filter(id => !excluded.includes(id));
    } catch (error) {
      console.error('[AppService] Erreur audiences', error);
      return [];
    }
  }

  async getAccessibleApps(): Promise<PortalApp[]> {
    try {
      const loggedIn = await this.keycloakAuth.isLoggedIn();
      if (!loggedIn) return [];

      await this.keycloakAuth.updateToken(5);
      const audiences = await this.getValidAudiences();

      const apps: PortalApp[] = [];
      for (const clientId of audiences) {
        const app = this.configService.getAppByClientId(clientId);
        if (app) apps.push(app);
        else console.warn(`[AppService] Aucune config pour clientId: ${clientId}`);
      }
      return apps;
    } catch (error) {
      console.error('[AppService] Erreur accessible apps', error);
      return [];
    }
  }

  async getUserRoles(): Promise<string[]> {
    return this.keycloakAuth.getUserRoles();
  }

  async hasAccessToApp(appIdOrClientId: string): Promise<boolean> {
    const apps = await this.getAccessibleApps();
    return apps.some(a => a.id === appIdOrClientId || a.clientId === appIdOrClientId);
  }

  getAllApps(): PortalApp[] {
    return this.configService.getAllApps();
  }

  getAppById(appId: string): PortalApp | undefined {
    let app = this.configService.getAppByClientId(appId);
    if (app) return app;
    return this.getAllApps().find(a => a.id === appId);
  }
}